import React, {useState, useContext, useEffect} from 'react';
import brand from '../../../branding';

import AppStateContext from "../../context/appStateContext";
import PageLayout from "../../components/pageLayout";
import PageHeader from "../../components/pageHeader";

import ScheduleTable from "../../../components/scheduleTable";
import {CALLING,POPULATED,EMPTY,TIMEOUT} from "../../../components/apiStatus";
import GetAssetsListFunction from "../../../functions/GetAssetsListFunction";
import HeaderImg from "../../../assets/images/headerImages/maintenance_header.png";
import APIHelper from "../../../hooks/useAPIHelper";
import useFilterHelper, { isGenericAsset } from '../../../hooks/useFilterHelper';

import {
  PageHeaderText,
  AccessMessage
} from "./index.style";
import ICONS from "../../../assets/icons";

const MaintenanceSchedule:React.FC<any> = () => {

  const { selectedCustomerId, token, setAppPageDetails, userPermissionsList, siteLogo, contactEmail } = useContext(AppStateContext);
  const [ assetList, setAssetList ] = useState([]);
  const [ apiStatus, setApiStatus ] = useState(CALLING);

  const getAssets = APIHelper();
  const { filterByContractServices } = useFilterHelper();

  // PORTAL-63. This previously ended on "else if(data.length > 0)" with no final
  // else. A single-asset customer arrived as a bare object, so length was undefined:
  // undefined == 0 is false AND undefined > 0 is false, so NEITHER branch ran and
  // apiStatus was left on its initial CALLING - the page sat on the loading spinner
  // for ever rather than showing anything. GetAssetsListFunction now always returns
  // an array; the terminal else means no future shape can reproduce the hang.
  const assetsCallback =(data: [] | string) => {
    if(data == 'timeout'){
      setApiStatus(TIMEOUT);
    } else if(!data || data.length == 0){
      setApiStatus(EMPTY);
    } else {
      // PORTAL-173. Exclude Generic-named assets here, same pattern as PORTAL-127's fix in
      // pages/assets/index.tsx - this is the only point the Maintenance Schedule table gets its
      // data, so filtering earlier here is the sole fix point.
      setAssetList(filterByContractServices(data).filter((item) => !isGenericAsset(item)));
      setApiStatus(POPULATED);
    }
  };

  useEffect(() => {
    setAppPageDetails('maintenanceSchedule');
    let filter:string = `<Filters><CustomerCode><Like>${selectedCustomerId}</Like></CustomerCode></Filters>`;
    getAssets.run(GetAssetsListFunction,assetsCallback,[filter,token,selectedCustomerId]);
  },[]);

  return (
    <PageLayout>
      <PageHeader backgroundImg={(brand.heroImages && brand.heroImages['maintenanceSchedule']) || brand.heroImage || siteLogo.background_image[3]['image']['url']}>
        <PageHeaderText>Maintenance Schedule</PageHeaderText>
      </PageHeader>
      {userPermissionsList.includes('view-schedule')?
        <ScheduleTable assetData={assetList} status={apiStatus}/>
        :
        <AccessMessage>
          <ICONS.alertTriangle/>
          <h2>You currently do not have permission to access this page, please contact {contactEmail}</h2>
        </AccessMessage>}
    </PageLayout>
  )
};

export default MaintenanceSchedule;

